export default __webpack_public_path__ + "static/media/haberlogo.627c12a3.svg";